export const MODULE_LABELS = {
  inicio: 'Visão geral', entrega: 'Entregas', delivery: 'Delivery', morador: 'Moradores',
  visitante: 'Visitantes', airbnb: 'Airbnb', contratado: 'Prestadores', agenda: 'Reservas',
  controle_acesso: 'Entrada e Saída', cameras: 'Controle de Acesso', abertura: 'Abertura Remota',
  cadastro_massa: 'Cadastro em Massa', whatsapp: 'WhatsApp', dispositivos: 'Dispositivos',
  grupos: 'Grupos', usuarios: 'Usuários do Sistema', configuracoes: 'Configurações', backup: 'Importar', logs: 'Logs',
};
export const PERMISSION_PARENTS = { airbnb: 'visitante', cameras: 'controle_acesso', cadastro_massa: 'abertura', grupos: 'dispositivos' };

export const MODULE_ROUTES = {
  inicio: '/inicio',
  airbnb: '/airbnb',
  cameras: '/controle-acesso/cameras',
  cadastro_massa: '/cadastro-em-massa',
  grupos: '/grupos',
  agenda: '/agenda',
  visitante: '/visitante',
  contratado: '/contratado',
  morador: '/morador',
  entrega: '/entrega',
  delivery: '/delivery',
  dispositivos: '/dispositivos',
  controle_acesso: '/controle-acesso',
  abertura: '/abertura',
  backup: '/importar',
  whatsapp: '/whatsapp',
  configuracoes: '/configuracoes',
  usuarios: '/usuarios-sistema',
  logs: '/logs',
};

export function hasPermission(auth, modulo, acao = 'visualizar') {
  if (!auth) return false;
  if (auth.user?.perfil === 'super_admin') return true;
  if (!Object.prototype.hasOwnProperty.call(auth.permissions || {}, modulo)) {
    if (PERMISSION_PARENTS[modulo]) return hasPermission(auth, PERMISSION_PARENTS[modulo], acao);
    if (modulo === 'inicio') return acao === 'visualizar' && Object.values(auth.permissions || {}).some((item) => item.visualizar);
  }
  return Boolean(auth.permissions?.[modulo]?.[acao]);
}

export function getFirstAllowedRoute(auth) {
  const order = Object.keys(MODULE_LABELS);
  const modulo = order.find((item) => hasPermission(auth, item, 'visualizar'));
  return modulo ? MODULE_ROUTES[modulo] : '/sem-permissao';
}
